export default "__VITE_ASSET__Cbk8NJ0I__"